import React, { useState } from 'react';
import { Table } from 'antd';

const { Column } = Table;

const BasicTable: React.FC<{
  items: any[];
  rowKey?: string;
  scrollHeight?: number;
  renderRow: (text: any, record: any, index: number) => React.ReactNode;
}> = ({ items, rowKey, renderRow, scrollHeight }) => {
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const gefaultPaginationConfig: any = {
    showSizeChanger: true,
    defaultPageSize: 40,
    position: 'both',
    size: 'small',
    onChange: (page: number, pageSize?: number) => {
      setCurrentPage(page);
      if (pageSize) setPageSize(pageSize);
    },
  };

  const renderRowCallback = React.useCallback(
    (text: any, record: any, index: number) => {
      return renderRow(text, record, (currentPage - 1) * pageSize + index);
    },
    [currentPage, pageSize, renderRow],
  );

  return (
    <Table
      showHeader={false}
      bordered
      dataSource={items}
      rowKey={rowKey || 'guid'}
      pagination={items.length <= 10 ? false : gefaultPaginationConfig}
      scroll={{
        y: scrollHeight || 900,
      }}
    >
      <Column key="renderRow" render={renderRowCallback} />
    </Table>
  );
};

export default React.memo(BasicTable);
